/**
 * Magic-link landing: /magic?mt=<token>
 * Exchanges the signed email-CTA token for a real session (httpOnly cookie),
 * then hard-navigates to the destination baked into the token so the app
 * boots with the fresh cookie. Expired/invalid links fall back to /login.
 */
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import api from '../services/api';

export default function MagicLoginPage() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const mt = new URLSearchParams(window.location.search).get('mt');
    if (!mt) { setError('This link is incomplete.'); return; }
    api.post('/auth/magic-exchange', { token: mt })
      .then((res) => {
        const { user, to } = res.data.data;
        try { localStorage.setItem('eqaya_user', JSON.stringify(user)); } catch (_) { /* non-fatal */ }
        window.location.replace(to && to.startsWith('/') ? to : '/dashboard');
      })
      .catch((e) => {
        setError(e.response?.data?.message || 'This link has expired. Please log in normally.');
      });
  }, []);

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 2 }}>
      {error ? (
        <>
          <Typography variant="h6">Link expired</Typography>
          <Typography color="text.secondary" sx={{ textAlign: 'center' }}>{error}</Typography>
          <Button variant="contained" href="/login">Go to login</Button>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography color="text.secondary">Signing you in…</Typography>
        </>
      )}
    </Box>
  );
}
